import React from "react";
import dayjs from "dayjs";

//MUI
import Grid from "@mui/material/Grid";

import PriceField from "Components/UI/Form/PriceField";
import DateWithClear from "Components/UI/Form/DateWithClear";

export default function InvoiceFormAgreement({
  formData,
  handleInputChange,
  FORM_MODE,
}) {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="FFD Datum"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            value={dayjs(formData.OriginalFfdDate)}
            onChange={(newVal) =>
              handleInputChange(
                "OriginalFfdDate",
                dayjs(newVal).format("YYYY-MM-DD")
              )
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="PM1 skapas datum"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            value={dayjs(formData.Pm1WaitCreateDate)}
            onChange={(newVal) =>
              handleInputChange(
                "Pm1WaitCreateDate",
                dayjs(newVal).format("YYYY-MM-DD")
              )
            }
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="PM1 FFD Datum"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            value={dayjs(formData.Pm1FfdDate)}
            onChange={(newVal) =>
              handleInputChange(
                "Pm1FfdDate",
                dayjs(newVal).format("YYYY-MM-DD")
              )
            }
          />
        </Grid>
        {/*
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            name="Pm1Interest"
            onChange={(e) => handleInputChange("Pm1Interest", e.target.value)}
            label="PM1 ränta %"
            value={formData.Pm1Interest}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>*/}
        {/* DEC */}
        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="Pm1Fee"
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(newVal) => handleInputChange("Pm1Fee", newVal)}
            label="PM1 avgift SEK"
            value={formData.Pm1Fee  === null ? 0 : formData.Pm1Fee}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>
        {/* DATE */}
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="PM2 skapas datum"
            value={dayjs(formData.Pm2WaitCreateDate)}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(newVal) =>
              handleInputChange(
                "Pm2WaitCreateDate",
                dayjs(newVal).format("YYYY-MM-DD")
              )
            }
          />
        </Grid>
        {/* DATE */}
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="PM2 FFD Datum"
            value={dayjs(formData.Pm2FfdDate)}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(newVal) =>
              handleInputChange(
                "Pm2FfdDate",
                dayjs(newVal).format("YYYY-MM-DD")
              )
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <PriceField
            name="Pm2Fee"
            onChange={(newVal) => handleInputChange("Pm2Fee", newVal)}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            label="PM2 avgift SEK"
            value={formData.Pm2Fee === null ? 0 : formData.Pm2Fee}
            size="small"
            color="primary"
            fullWidth
            margin="dense"
            type="number"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <DateWithClear
            label="Inkasso skapas datum"
            value={dayjs(formData.CollectionWaitCreateDate)}
            disabled={FORM_MODE === "LOCKED" ? true : false}
            onChange={(newVal) =>
              handleInputChange(
                "CollectionWaitCreateDate",
                dayjs(newVal).format("YYYY-MM-DD")
              )
            }
          />
        </Grid>
      </Grid>
    </>
  );
}
